import { Grid, GridProps } from '@mui/material';
import React from 'react';

interface Properties extends GridProps {}

interface State {}

class ResponsiveGridContainer extends React.Component<Properties, State> {
  render() {
    const { children, ...rest } = this.props;

    return (
      <Grid container {...rest} spacing={1}>
        {children}
      </Grid>
    );
  }
}

export default ResponsiveGridContainer;
